import React, { useState, useEffect } from 'react';
import LoginPage from './components/LoginPage';
import ChatPage from './components/ChatPage';
import './App.css';

function App() {
  // Global application state
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userData, setUserData] = useState({
    userId: null,
    userName: null,
    sessionId: null,
    sessionName: null,
    messages: []
  });

  // Load saved session from localStorage on mount
  useEffect(() => {
    const savedSession = localStorage.getItem('pritam_session');
    if (savedSession) {
      try {
        const parsed = JSON.parse(savedSession);
        setUserData(parsed);
        setIsLoggedIn(true);
      } catch (err) {
        console.error('Failed to load saved session:', err);
        localStorage.removeItem('pritam_session');
      }
    }
  }, []);

  // Save session to localStorage whenever userData changes
  useEffect(() => {
    if (isLoggedIn && userData.userId) {
      localStorage.setItem('pritam_session', JSON.stringify(userData));
    }
  }, [isLoggedIn, userData]);

  // Handle successful login
  const handleLoginSuccess = (data) => {
    setUserData(data);
    setIsLoggedIn(true);
  };

  // Handle logout
  const handleLogout = () => {
    setIsLoggedIn(false);
    setUserData({
      userId: null,
      userName: null,
      sessionId: null,
      sessionName: null,
      messages: []
    });
    localStorage.removeItem('pritam_session');
  };

  // Update session data (called from ChatPage)
  const updateSessionData = (updates) => {
    setUserData(prev => ({
      ...prev,
      ...updates
    }));
  };

  return (
    <div className="App">
      {!isLoggedIn ? (
        <LoginPage onLoginSuccess={handleLoginSuccess} />
      ) : (
        <ChatPage 
          userData={userData}
          onLogout={handleLogout}
          onUpdateSession={updateSessionData}
        />
      )}
    </div>
  );
}

export default App;
